(function () {
  'use strict';

  function prefersReducedMotion() {
    return typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (typeof flatpickr === 'undefined') return;
    root = root || document;

    root.querySelectorAll('.date-picker-wrap').forEach(function (wrap) {
      if (wrap._flatpickr) return;

      flatpickr(wrap, {
        wrap: true,
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
        minDate: 'today',
        disableMobile: true,
        animate: !prefersReducedMotion(),
        monthSelectorType: 'static',
        onReady: function (_selectedDates, _dateStr, instance) {
          instance.calendarContainer.classList.add('ms-datepicker');
        }
      });
    });
  }

  function clearWrap(wrap) {
    if (wrap && wrap._flatpickr) {
      wrap._flatpickr.clear();
      return;
    }
    var input = wrap && wrap.querySelector('[data-input]');
    if (input) input.value = '';
  }

  window.MSDatePicker = {
    init: init,
    clearWrap: clearWrap
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
